/**
 * Constants for Anthropic API client
 */

export const RETRYABLE_ANTHROPIC_STATUS_CODES = new Set([429, 500, 502, 503, 529]);

// Route all browser traffic through same-origin proxy to avoid CORS blocks.
export const ANTHROPIC_API_BASE = import.meta.env.VITE_ANTHROPIC_API_BASE || '/api/anthropic/v1';
export const ANTHROPIC_VERSION = '2023-06-01';
export const ANTHROPIC_FAST_MODE_BETA = 'fast-mode-2026-02-01';

// Kept short because proper 429 + Retry-After handling is now in place.
// Anthropic docs: "burst (e.g., downloading paginated data) is acceptable."
export const MIN_REQUEST_INTERVAL = 300; // Minimum 300ms between requests (burst-friendly)

// Retry configuration
export const MAX_RETRIES = 5;
export const BASE_DELAY = 3000; // 3 second base delay
